module.exports = __webpack_public_path__ + "static/ASCOVIME-5cc00ac8d259b37e9ddf9e4954901f12.jpeg";